import { muiStyles } from 'utils/design';

export const useStyles = muiStyles({
  grid: {
    flexGrow: 1,
  },
});
